import { useEffect } from 'react'

import { createFileRoute } from '@tanstack/react-router'

import ListPoktanMemberPage from '@/components/pages/guest/_list-member-poktan/containers/list-poktan-member-page'
import { useFilters } from '@/components/pages/guest/_list-member-poktan/state/filters-atom'
import { searchParamsSchema } from '@/components/pages/guest/_list-member-poktan/types'

export const Route = createFileRoute('/_guest/guest/list-poktan-member')({
  component: RouteComponent,
  validateSearch: searchParamsSchema
})

function RouteComponent() {
  const search = Route.useSearch()
  const filters = useFilters()

  useEffect(() => {
    if (search.poktan_id) {
      filters.onPoktanChange(search.poktan_id, false)
    }
    if (search.province_code) {
      filters.onProvinceChange(search.province_code, false)
    }
    if (search.city_code) {
      filters.onCityChange(search.city_code, false)
    }
    if (search.district_code) {
      filters.onDistrictChange(search.district_code, false)
    }
    if (search.village_code) {
      filters.onVillageChange(search.village_code, false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    search.poktan_id,
    search.province_code,
    search.city_code,
    search.district_code,
    search.village_code
  ])

  return <ListPoktanMemberPage />
}
